import { actions } from './actions'

const initialState = {
  productosGenericos: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosGenericosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTO_GENERICO_LOAD_REQUESTED:
      return { ...state, productosGenericos: { ...state.productosGenericos, loading: true } }
    case actions.PRODUCTO_GENERICO_LOAD_SUCCEEDED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, data: action.payload, loading: false },
      }
    case actions.PRODUCTO_GENERICO_LOAD_FAILED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: false, error: action.error },
      }
    case actions.PRODUCTO_GENERICO_INSERT_REQUESTED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: true, error: '' },
      }
    case actions.PRODUCTO_GENERICO_INSERT_SUCCEEDED:
      return {
        ...state,
        productosGenericos: {
          ...state.productosGenericos,
          data: [...state.productosGenericos.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_GENERICO_INSERT_FAILED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: false, error: action.error },
      }

    case actions.PRODUCTO_GENERICO_UPDATE_REQUESTED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: true, error: '' },
      }
    case actions.PRODUCTO_GENERICO_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updated = state.productosGenericos.data.map(generico => {
        if (generico.id === action.payload.id) {
          return action.payload
        }
        return generico
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        productosGenericos: {
          ...state.productosGenericos,
          data: updated,
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_GENERICO_UPDATE_FAILED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: false, error: action.error },
      }

    case actions.PRODUCTO_GENERICO_DELETE_REQUESTED:
      return { ...state, productosGenericos: { ...state.productosGenericos, loading: true } }
    case actions.PRODUCTO_GENERICO_DELETE_SUCCEEDED:
      return {
        ...state,
        productosGenericos: {
          ...state.productosGenericos,
          loading: false,
          data: state.productosGenericos.data.filter(
            productosGenericos => productosGenericos.id !== action.id,
          ),
        },
      }
    case actions.PRODUCTO_GENERICO_DELETE_FAILED:
      return {
        ...state,
        productosGenericos: { ...state.productosGenericos, loading: false },
      }

    default:
      return state
  }
}
